"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FooterSocialIcon = void 0;
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const fa_1 = require("react-icons/fa");
function FooterSocialIcon(_a) {
    var { className, href, type } = _a, props = __rest(_a, ["className", "href", "type"]);
    return (react_1.default.createElement("a", Object.assign({ href: href, className: (0, classnames_1.default)('w-14 h-14 inline-flex justify-center items-center text-3xl bg-gray-5 rounded-full text-white transition hover:bg-gray-9', className) }, props),
        type === 'facebook' && (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("span", { className: "sr-only" }, "Facebook"),
            react_1.default.createElement(fa_1.FaFacebookF, null))),
        type === 'twitter' && (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("span", { className: "sr-only" }, "Twitter"),
            react_1.default.createElement(fa_1.FaTwitter, null))),
        type === 'instagram' && (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("span", { className: "sr-only" }, "Instagram"),
            react_1.default.createElement(fa_1.FaInstagram, null))),
        type === 'linkedin' && (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("span", { className: "sr-only" }, "LinkedIn"),
            react_1.default.createElement(fa_1.FaLinkedinIn, null)))));
}
exports.FooterSocialIcon = FooterSocialIcon;
